// Global Instructions Rule Applied!
//
// Section-component registry for the in-app help drawer.
//
// A cfg.help_article_sections row can carry a `component_key`. When it does,
// the drawer renders the component registered here AFTER that section's prose
// — which is how a guide section shows live, data-driven UI instead of copy
// frozen into HTML at seed time.
//
// This lives in ui_configs/ rather than core/ for the same reason iconMap.tsx
// does: it maps app-level keys onto app-module components, and core must not
// depend on app_modules.
//
// An unrecognised key renders nothing. That is deliberate — a cfg row must
// never be able to blank a guide, and content can be seeded ahead of the
// component that will eventually render it.

import type { ComponentType } from 'react'
import { AgentClientGuides } from '../app_modules/agent_access/components/AgentClientGuides.tsx'

export const HELP_SECTION_COMPONENTS: Record<string, ComponentType> = {
  // Connected Agents → "Step 2 — add it in your assistant". Renders one block
  // per assistant from cfg.agent_client_guides, so adding another assistant is
  // an INSERT rather than a change here.
  agent_client_guides: AgentClientGuides
}

export const getHelpSectionComponent = (
  componentKey: string | null | undefined
): ComponentType | null => {
  if (!componentKey) return null
  return HELP_SECTION_COMPONENTS[componentKey] ?? null
}
